import {Field} from 'react-final-form';

import {useUpdateUserSettingsMutation} from 'src/hooks/useUserProfile';
import {ApiUserProfile, WeatherDisplay} from 'src/lib/api/auth';
import * as tw from 'src/lib/tailwindClasses';
import FormSection from 'src/pages/Settings/FormSection';

import {recordEvent} from './Analytics';
import {useTranslations} from './TranslationsContext';

export default function DefaultWeatherDisplaySelector({
  currentUser,
}: {
  currentUser: ApiUserProfile;
}) {
  const {t} = useTranslations();
  const updateSettings = useUpdateUserSettingsMutation();

  return (
    <FormSection
      name={t('chartPreferences')}
      description={t('chartPreferencesDescription')}
      isLoading={updateSettings.isLoading}
      initialValues={{
        defaultWeatherDisplay: currentUser.settings?.defaultWeatherDisplay ?? 'forecastPoint',
      }}
      onSubmit={(values) => {
        const defaultWeatherDisplay = values.defaultWeatherDisplay as WeatherDisplay;
        recordEvent('default_weather_display_changed', {value: defaultWeatherDisplay});
        updateSettings.mutate({defaultWeatherDisplay});
      }}
      render={() => (
        <div className="col-span-6 sm:col-span-3">
          <label
            htmlFor="defaultWeatherDisplay"
            className="block text-sm font-medium text-gray-700"
          >
            {t('defaultWeatherViewLabel')}
          </label>
          <Field name="defaultWeatherDisplay" component="select" className={tw.formSelect}>
            <option value="forecastPoint">{t('forecastPoint')}</option>
            <option value="basinAverage">{t('basinAverage')}</option>
          </Field>
        </div>
      )}
    />
  );
}
